import { AxesHelper, Group, LineBasicMaterial } from "three";
import { CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer.js";

const AXIS_SIZE = 1.1;
const LABEL_OFFSET = AXIS_SIZE + 0.08;

/**
 * 立方体とは独立にワールド XYZ 軸のガイドを描画する。
 * scene 直下に配置することで root の回転に追従せず、常にワールドの方向を示す。
 * X = 赤 / Y = 緑 / Z = 青 (Three.js の AxesHelper 標準色)、各軸先端に CSS2D
 * のテキストラベルを乗せる。
 *
 * 凸包メッシュに隠れないよう、AxesHelper のマテリアルは depthTest 無効 +
 * renderOrder 最大とし、常に立方体の手前に描画する。
 */
export class AxesGuide {
  readonly group: Group;

  constructor() {
    this.group = new Group();
    const helper = new AxesHelper(AXIS_SIZE);
    const mat = helper.material as LineBasicMaterial;
    mat.depthTest = false;
    mat.depthWrite = false;
    mat.transparent = true;
    helper.renderOrder = 999;
    this.group.add(helper);
    this.group.add(this.makeLabel("X", "#ff6b86", LABEL_OFFSET, 0, 0));
    this.group.add(this.makeLabel("Y", "#7be08c", 0, LABEL_OFFSET, 0));
    this.group.add(this.makeLabel("Z", "#7baeff", 0, 0, LABEL_OFFSET));
  }

  private makeLabel(
    text: string,
    color: string,
    x: number,
    y: number,
    z: number,
  ): CSS2DObject {
    const el = document.createElement("div");
    el.className = "axis-label";
    el.textContent = text;
    el.style.color = color;
    const obj = new CSS2DObject(el);
    obj.position.set(x, y, z);
    obj.center.set(0.5, 0.5);
    return obj;
  }

  setVisible(visible: boolean): void {
    this.group.visible = visible;
  }
}
